import {
  Button,
  Card,
  CardContent,
  IconButton,
  TextField,
  Typography
} from '@mui/material'
import { getEmailValidationState } from '../../../utils/email'
import css from './DatosEmail.module.css'

const DatosEmail = ({ emails, onChange }) => {
  const handleAddEmail = () => {
    onChange([...emails, { nombre: '', email: '', observaciones: '' }])
  }

  const handleRemoveEmail = index => {
    const newEmails = emails.filter((_, i) => i !== index)
    onChange(newEmails)
  }

  const handleUpdateEmail = (index, field, value) => {
    const newEmails = [...emails]
    newEmails[index] = {
      ...newEmails[index],
      [field]: value
    }
    onChange(newEmails)
  }

  return (
    <Card className={css.card}>
      <CardContent className={css.cardContent}>
        <Typography variant='h6' className={css.cardTitle}>
          Datos de email
        </Typography>
        {emails.map((email, index) => {
          const status = getEmailValidationState(email)
          return (
            <div key={index} className={css.row}>
              <div className={css.inputsContainer}>
                <TextField
                  name={`nombre-${index}`}
                  className={css.contactoInput}
                  label='Nombre'
                  type='text'
                  variant='standard'
                  value={email.nombre}
                  onChange={e =>
                    handleUpdateEmail(index, 'nombre', e.target.value)
                  }
                />
                <TextField
                  name={`email-${index}`}
                  className={css.emailInput}
                  label='Email'
                  type='email'
                  variant='standard'
                  value={email.email}
                  onChange={e =>
                    handleUpdateEmail(index, 'email', e.target.value)
                  }
                />
              </div>
              <div className={css.actions}>
                <IconButton
                  className={css.removeButton}
                  onClick={() => handleRemoveEmail(index)}
                  size='small'
                  color='error'
                >
                  <span className='material-icons'>delete</span>
                </IconButton>
                <span
                  className={`material-icons ${css.icon}`}
                  data-status={status}
                >
                  {status === 'success' && 'check_circle'}
                  {status === 'warning' && 'warning'}
                  {status === 'error' && 'error'}
                </span>
              </div>
            </div>
          )
        })}
        <Button
          className={css.addButton}
          variant='outlined'
          color='primary'
          onClick={handleAddEmail}
          startIcon={<span className='material-icons'>add</span>}
        >
          Añadir email
        </Button>
      </CardContent>
    </Card>
  )
}

export default DatosEmail
